import apiHandler from "../core/apiHandler";

const electronicTemplateApi = apiHandler('electronic-document-templates');
export default electronicTemplateApi;